/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PersistencyPayoutUpdateRequestDTO } from '../models/PersistencyPayoutUpdateRequestDTO';
import { request as __request } from '@openapi/request';

export class PersistencySetupService {

    /**
     * @returns any Retrieve the list of payout rates
     * @throws ApiError
     */
    public static async retreivePersistencyPayoutList(): Promise<any> {
        const result = await __request({
            method: 'GET',
            path: `/web/api/production-bonus-setup/persistency/list`,
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns any Update the list of payout rates
     * @throws ApiError
     */
    public static async updatePersistencyPayout(
        requestBody: PersistencyPayoutUpdateRequestDTO,
    ): Promise<any> {
        const result = await __request({
            method: 'POST',
            path: `/web/api/production-bonus-setup/persistency/update`,
            body: requestBody,
        });
        return result.body;
    }

}